const WorkLocationReadOnlyRow = ({t, location, handleEditClick, handleDeleteClick, oddIdx}) => {
	return(
		<tr>
            <td className={oddIdx?"list-td col text-wrap odd": "list-td col text-wrap even"}>{location.locationName}</td>
             <td className={oddIdx?"list-td col text-wrap odd": "list-td col text-wrap even"}>{location.operationTypeDesc}</td>
              <td className={oddIdx?"list-td col text-wrap odd": "list-td col text-wrap even"}>{location.operationArea}</td>
            <td className={oddIdx?"list-td col text-wrap odd": "list-td col text-wrap even"}>{location.description}</td>
            <td className={oddIdx?"list-td col text-wrap odd": "list-td col text-wrap even"}>{location.address}</td>
            <td className={oddIdx?"list-td col odd": "list-td col even"}>{location.phone}</td>
            <td className={oddIdx?"list-td col odd": "list-td col even"}>{location.status}</td>
            <td className={oddIdx?"list-td col col-md-auto odd": "list-td col col-md-auto even"}> 
             <button className="btn btn-primary btn-block me-2 mb-1" data-toggle="modal" data-target="#locationModal"
             	onClick={(event) => handleEditClick(event, location)}>{t("page.edit")}</button>
            <button className="btn btn-primary btn-block me-2 mb-1" onClick={(event) => handleDeleteClick(event, location.locationKey, location.statusCode)}>{location.statusCode === 1? t("page.delete") : t("page.undelete")}</button>
            </td>
         </tr>
	)
}
export default WorkLocationReadOnlyRow;